/** Per-source waste amounts shown on the waste-stream grids. */
export type WasteStreamAmounts = {
  vendorAmount?: number | null;
  eManifestAmount?: number | null;
  documentAmount?: number | null;
};

/**
 * Tooltip copy explaining the consolidated "Amount" value. This is the same
 * effective amount Encamp reports to RCRAInfo: per shipment line, e-Manifest
 * is preferred, then vendor, then a reviewed manifest document.
 */
export const WASTE_AMOUNT_TOOLTIP =
  "The amount Encamp will report. When a shipment line has an e-Manifest amount, it takes priority over vendor and document amounts because the e-Manifest is what we report to regulators. Vendor amounts, then amounts from reviewed manifest documents, are used only when no e-Manifest amount is reported.";
